import React from "react";

import classNames from "classnames";

const INDEX_SELECTION_ICON_BASE =
  "inline-block min-h-[20px] min-w-[20px] text-center text-[10px] leading-5 border";

export const IndexIcon: React.FunctionComponent<{
  label: string;
  selected?: boolean;
  existing?: boolean;
  className?: string;
}> = ({ label, className, existing, selected }) => {
  const indexVariantClass =
    existing && selected
      ? "bg-[#544D6D] hover:bg-[#30284D] text-white border-transparent"
      : existing
      ? "bg-[#EB1515] hover:bg-[#C9302C] text-white border-transparent"
      : selected
      ? "bg-link hover:bg-[#1C7699] text-white border-transparent"
      : "bg-white text-[#544D6D] hover:text-link-hover border-[#544D6D] hover:border-link-hover";

  return (
    <div
      className={classNames(
        INDEX_SELECTION_ICON_BASE,
        "rounded-sm",
        indexVariantClass,
        className,
      )}
    >
      {label}
    </div>
  );
};

export const SeqScanIcon: React.FunctionComponent<{
  className?: string;
}> = ({ className }) => {
  const seqScanClassName = "bg-[#544D6D] hover:bg-[#30284D] text-white";
  return (
    <div
      className={classNames(
        INDEX_SELECTION_ICON_BASE,
        "rounded-sm border-transparent",
        seqScanClassName,
        className,
      )}
    >
      Seq
    </div>
  );
};

export const ScanIcon: React.FunctionComponent<{
  label: string;
  className?: string;
}> = ({ label, className }) => {
  return (
    <div
      className={classNames(
        INDEX_SELECTION_ICON_BASE,
        "bg-[#544D6D] hover:bg-[#30284D] text-white rounded-full border-transparent",
        className,
      )}
    >
      {label}
    </div>
  );
};
